import React, { useCallback } from 'react';
import { DataTable } from 'components/data-table';
import { format0 } from 'utils/number';
import { useDevelopmentAreasQuery } from './hooks';
import type { DevelopmentArea, TypeCurveHeader } from 'types/api-responses';
import style from './type-curve-wells-table.module.scss';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from 'components/accordion/accordion';
import { unitsTableColumns } from './units-table-columns';

interface UnitsTableProps {
  typeCurveHeader: TypeCurveHeader;
}

export const UnitsTable: React.FC<UnitsTableProps> = ({ typeCurveHeader }) => {
  const { units, totalCount, isLoading, error, loadData } =
    useDevelopmentAreasQuery(typeCurveHeader);

  const getRowId = useCallback((row: DevelopmentArea) => String(row.id), []);

  return (
    <Accordion defaultExpanded className={style.accordionRoot}>
      <AccordionSummary>
        <h2 className={style.typeCurveWellsTitle}>
          Units ({format0(totalCount)})
        </h2>
      </AccordionSummary>
      <AccordionDetails className={style.accordionDetails}>
        <div className={style.tableContainer}>
          <DataTable<DevelopmentArea>
            data={units}
            columns={unitsTableColumns}
            getRowId={getRowId}
            isLoading={isLoading}
            error={error}
            persistenceKey="type-curve-units-table"
            scroll={{ mode: 'paginated', serverDriven: true, totalCount }}
            onPaginationChange={loadData}
            onSortChange={loadData}
            onFilterChange={loadData}
            onGlobalSearchChange={loadData}
            config={{
              columnResizing: true,
              columnReordering: true,
              columnPinning: true,
              sorting: true,
              columnVisibility: true,
              globalSearch: true,
              columnFilters: false,
              export: true,
            }}
            searchPlaceholder="Search units..."
          />
        </div>
      </AccordionDetails>
    </Accordion>
  );
};
